/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * This is a list of error codes generated by this service.
 *
 * In addition to these error codes, errors that are generated by Auth0 / APW will also have a
 * "apw_error" field with the original payload of that error.
 *
 * This list is meant to identify errors for easier client integration, but it should be
 * treated as non-comprehensive.
 */
export var ErrorCodes;
(function (ErrorCodes) {
  ErrorCodes["downstream_server_issue"] = "downstream_server_issue";
  ErrorCodes["expired_reset_token"] = "expired_reset_token";
  ErrorCodes["inactive_user"] = "inactive_user";
  ErrorCodes["internal_error"] = "internal_error";
  ErrorCodes["invalid_device"] = "invalid_device";
  ErrorCodes["invalid_email"] = "invalid_email";
  ErrorCodes["invalid_email_structure"] = "invalid_email_structure";
  ErrorCodes["invalid_params"] = "invalid_params";
  ErrorCodes["invalid_recaptcha"] = "invalid_recaptcha";
  ErrorCodes["invalid_reset_token"] = "invalid_reset_token";
  ErrorCodes["invalid_user"] = "invalid_user";
  ErrorCodes["merged_client_credentials_used"] = "merged_client_credentials_used";
  ErrorCodes["mfa_required"] = "mfa_required";
  ErrorCodes["migration_client"] = "migration_client";
  ErrorCodes["old_password"] = "old_password";
  ErrorCodes["slow_down"] = "slow_down";
  ErrorCodes["user_already_exists"] = "user_already_exists";
  ErrorCodes["user_already_exists_migrated"] = "user_already_exists_migrated";
  ErrorCodes["user_not_found"] = "user_not_found";
  ErrorCodes["wrong_password"] = "wrong_password";
})(ErrorCodes || (ErrorCodes = {}));
export var ResetPasswordStatus;
(function (ResetPasswordStatus) {
  ResetPasswordStatus["Fail"] = "Fail";
  ResetPasswordStatus["Success"] = "Success";
})(ResetPasswordStatus || (ResetPasswordStatus = {}));
export var SsoProviders;
(function (SsoProviders) {
  SsoProviders["apple"] = "apple";
  SsoProviders["facebook"] = "facebook";
  SsoProviders["google"] = "google";
  SsoProviders["microsoft"] = "microsoft";
})(SsoProviders || (SsoProviders = {}));
export var Status;
(function (Status) {
  Status["FAIL"] = "FAIL";
  Status["SUCCESS"] = "SUCCESS";
})(Status || (Status = {}));
export var StudentType;
(function (StudentType) {
  StudentType["college"] = "college";
  StudentType["highschool"] = "highschool";
})(StudentType || (StudentType = {}));
export var TokenType;
(function (TokenType) {
  TokenType["accessToken"] = "accessToken";
  TokenType["authorizationCode"] = "authorizationCode";
  TokenType["idToken"] = "idToken";
})(TokenType || (TokenType = {}));
export var UserType;
(function (UserType) {
  UserType["parent"] = "parent";
  UserType["student"] = "student";
  UserType["teacher"] = "teacher";
})(UserType || (UserType = {})); //==============================================================
// END Enums and Input Objects
//==============================================================